// VLX Address
const VLX_ADDRESS = '0xc579d1f3cf86749e05cd06f7ade17856c2ce3126'

export { VLX_ADDRESS }
